export type WalkthroughStep = {
  text: string;
  screen?: string;
  target?: string;
  show?: Array<string>;
  hide?: Array<string>;
  on?: Array<string>;
  off?: Array<string>;
};

export type WalkthroughView = {
  screen: string | undefined;
  shows: (key: string, initially?: boolean) => boolean;
  isOn: (key: string, initially?: boolean) => boolean;
};

export const GUIDE_TARGET_ATTRIBUTE = "data-guide-target";
export const GUIDE_INNER_ATTRIBUTE = "data-guide-inner";

export type GuideTargetProps = {
  "data-guide-target": string;
  "data-guide-inner"?: string;
};

export const guideTarget = (id: string, inner?: string): GuideTargetProps =>
  inner
    ? { "data-guide-target": id, "data-guide-inner": inner }
    : { "data-guide-target": id };

export const resolveWalkthroughView = (
  steps: Array<WalkthroughStep>,
  index: number
): WalkthroughView => {
  let screen: string | undefined;
  const shown: Record<string, boolean> = {};
  const on: Record<string, boolean> = {};

  steps.slice(0, index + 1).forEach((step) => {
    screen = step.screen ?? screen;
    step.show?.forEach((key) => {
      shown[key] = true;
    });
    step.hide?.forEach((key) => {
      shown[key] = false;
    });
    step.on?.forEach((key) => {
      on[key] = true;
    });
    step.off?.forEach((key) => {
      on[key] = false;
    });
  });

  return {
    screen,
    shows: (key, initially = false) => shown[key] ?? initially,
    isOn: (key, initially = false) => on[key] ?? initially,
  };
};
